import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem } from './styles';

// ----------------------------------------------------------------------

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data?.map((item, index) => (
          <NavItem key={index} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------


function NavItem({ item }) {
  const { title, path, icon: IconComponent, info, breadCrumbs, tourId } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      data-tour={tourId}
      className={tourId ? `tour-target-${tourId}` : ''}
      sx={{
        color: breadCrumbs && breadCrumbs.includes(window.location.pathname) ? 'text.titles' : 'text.primary',
        textDecoration: 'none !important',
        pl: '17.4px',
        mb: '20px',
        outline: 'none !important',
        fontWeight: 500,

        '&.active': {
          color: 'white',
          bgcolor: 'primary.main',
          fontWeight: 600,
          '& .MuiSvgIcon-root': {
            color: 'white',
            // Remove transform to prevent spotlight calculation issues
            // transform: 'scale(1.1)',
            opacity: 1,
          },
          '& .icon-container': {
            backgroundColor: 'primary.dark',
            boxShadow: '0px 4px 12px rgba(86, 156, 211, 0.3)',
            // Add scale to container instead
            transform: 'scale(1.05)',
          }
        },
        bgcolor: breadCrumbs && breadCrumbs.includes(window.location.pathname) && 'action.selected',
        ...(breadCrumbs && breadCrumbs.includes(window.location.pathname) && {
          color: 'white',
          bgcolor: 'primary.main',
          fontWeight: 600,
          '& .MuiSvgIcon-root': {
            color: 'white',
            opacity: 1,
          },
          '& .icon-container': {
            backgroundColor: 'primary.dark',
            boxShadow: '0px 4px 12px rgba(86, 156, 211, 0.3)',
            transform: 'scale(1.05)',
          }
        }),

        pointerEvents: path === 'NA' && 'none',
        opacity: path === 'NA' && 0.3,
        '& .MuiSvgIcon-root': {
          color: 'primary.main',
          fontSize: '1.25rem',
          opacity: 1,
        }
      }}
    >
      {IconComponent && (
        <Box
          className="icon-container"
          sx={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: breadCrumbs && breadCrumbs.includes(window.location.pathname) 
              ? 'primary.main' 
              : 'primary.lighter',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: '16.44px',
            boxShadow: breadCrumbs && breadCrumbs.includes(window.location.pathname)
              ? '0px 4px 12px rgba(86, 156, 211, 0.25)'
              : '0px 2px 8px rgba(86, 156, 211, 0.15)',
            transition: 'transform 0.2s ease-in-out',
          }}
        >
          <IconComponent 
            sx={{ 
              color: breadCrumbs && breadCrumbs.includes(window.location.pathname) 
                ? 'white' 
                : 'primary.main',
              fontSize: '1.25rem',
              display: 'block',
              minWidth: '20px',
              minHeight: '20px',
              opacity: 1
            }} 
          />
        </Box>
      )}

      <ListItemText disableTypography primary={title} sx={{ fontSize: '14px' }} />

      {info && info}
    </StyledNavItem>
  );
}
